'use client';

import React from 'react';

interface DrawerPanelProps {
  isOpen: boolean;
  onClose: () => void;
  side?: 'left' | 'right';
  width?: string;
  children: React.ReactNode;
}

export const DrawerPanel: React.FC<DrawerPanelProps> = ({
  isOpen,
  onClose,
  side = 'right',
  width = 'max-w-xs',
  children,
}) => {
  // Lock body scrolling when the drawer is open to prevent background scrolling
  React.useEffect(() => {
    if (isOpen) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className={`fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex animate-fade-in ${
        side === 'right' ? 'justify-end' : 'justify-start'
      }`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`w-full ${width} bg-slate-50 h-full shadow-2xl flex flex-col ${
          side === 'right'
            ? 'border-l border-slate-200/80 animate-slide-from-right'
            : 'border-r border-slate-200/80 animate-slide-from-left'
        }`}
      >
        {children}
        <div className="flex-shrink-0 py-2 text-center">
          <span className="text-[10px] text-slate-300 font-medium select-none">v{__APP_VERSION__}</span>
        </div>
      </div>
    </div>
  );
};
